import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-promocion',
  templateUrl: './promocion.component.html',
  styleUrls: ['./promocion.component.css']
})
export class PromocionComponent implements OnInit {
  dataActual: any = null;

  infoPromo: any = {
//     clientesContrato: {
//       titulo: "¡AÑO NUEVO, ENVÍOS CON MÁS DESCUENTO!",
//       descripcion: `Reactiva tu cuenta prepago descuento y sube tu porcentaje de descuento en TUFESAPACK.
// Promoción válida del 15 al 31 de enero de 2026.

// ¿Eres cliente nuevo o dejaste de enviar recientemente? Esta promo es para ti: firma o renueva tu contrato prepago y obtén un mejor descuento según el monto de tu depósito.`,


//       beneficios: [
//         "Firma o renueva tu contrato (prepago) dentro del periodo de la promo.",
//         "Realiza tu primer depósito en el rango que prefieras.",
//         "Activa tu nuevo % de descuento y empieza a enviar más por menos del 15 al 31 de enero del 2026."
//       ],

    
//       niveles: [
//         { deposito: "$8,500.00 a $10,499.99", descuento: "35% de descuento" },
//         { deposito: "$10,500.00 a $12,499.99", descuento: "40% de descuento" },
//         { deposito: "$12,500.00 o más", descuento: "45% de descuento" }
//       ],
//       notaNiveles: "Entre mayor sea tu depósito, mayor es tu descuento.",

    
//       aplican: [
//         "✅ Clientes nuevos (primer contrato + primer consumo)",
//         "✅ Clientes con cuenta sin movimiento (actividad cero en los últimos 3 meses)"
//       ],

//       terminos: [
//         "Promoción válida únicamente del 15 al 31 de enero de 2026.",
//         "Aplicable solo para clientes con contrato prepago descuento (nuevo o renovado durante la vigencia).",
//         "Elegible para: Cliente nuevo con primer contrato y primer consumo, o Cliente con actividad cero en los últimos 3 meses previos a la contratación/renovación.",
//         "El porcentaje de descuento se asigna de acuerdo con el monto depositado dentro de los rangos establecidos. Si el cliente realiza una recarga posterior por un monto menor al que le otorgó un porcentaje mayor de descuento, todo el saldo acumulado será recalculado automáticamente al porcentaje inferior que corresponda.",
//         "El depósito y consumo debe realizarse dentro del periodo promocional para que aplique el beneficio.",
//         "El descuento aplica exclusivamente a envíos facturados bajo el contrato prepago descuento del cliente.",
//         "No es acumulable con otras promociones, convenios especiales o descuentos adicionales (salvo autorización expresa por escrito).",
//         "El descuento no es canjeable por efectivo, no es transferible y no aplica a saldos previos.",
//         "Sujeto a validación por el área comercial y a disponibilidad del servicio/cobertura.",
//         "A partir del 01 de febrero, el saldo acumulado durante la promoción de prepago descuento será aplicado a su descuento bajo el esquema tradicional.",
//         "La realización de cualquier recarga dentro del periodo promocional implica la aceptación total de las presentes restricciones, sin derecho a aclaraciones, ajustes, devolución de efectivo o reclamaciones posteriores.",
//         "TUFESAPACK se reserva el derecho de modificar o suspender la promoción por causas de fuerza mayor o disposiciones operativas, respetando beneficios ya activados en el periodo, cuando aplique."
//       ],

//       imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_clientesContrato.webp",
//     },
    // promonavidad2025:{
    //   titulo: "🎅✨ ¡La Magia de la Navidad llegó a TUFESAPACK! ✨🎄",
    //   descripcion:`Participa y gana la Caja Mágica TUFESAPACK con $5,000 en sorpresas 🎁\n
    //   Esta temporada queremos agradecer tu preferencia con un regalo muy especial. Del 01 al 20 de diciembre, cada envío que realices puede acercarte a ganar nuestra exclusiva Caja Mágica TUFESAPACK: un premio en especie compuesto por artículos navideños, promocionales y tarjeta de regalo para tienda departamental, con un valor de $5,000 MXN.\n
    //   🎁 ¿Cómo participar?`,
    //   beneficios: [
    //     "Realiza un envío en cualquier sucursal TUFESAPACK.",
    //     "Recibe tu PACK Esfera en mostrador (1 por cliente por día).",
    //     "Llena tus datos y deposítala en el buzón navideño de la sucursal.",
    //     "Promoción válida en toda la cobertura de sucursales TUFESAPACK.",
    //     "🎅¡Cada PACK Esfera es una oportunidad para ganar!"
    //   ],
    //   fechasimportantes:`📅 Fechas importantes\n
    //   Participación válida del: 01 al 20 de diciembre o hasta agotar existencias.
    //   Sorteo: 20 de diciembre a las 12:00 horas (Tiempo del Pacífico) mediante Facebook Live en la página oficial de TUFESAPACK.
    //   Entrega del premio: 22 de diciembre.`,
    //   terminos:[
    //     "Válido en todas las sucursales TUFESAPACK de México hasta agotar existencias.",
    //     "Una PACK Esfera por cliente por día, sin importar el número de envíos en la misma fecha.",
    //     "Aplican términos y condiciones.",
    //     "El premio no es transferible, no puede canjearse por dinero ni por otros productos o beneficios. Su entrega se realizará únicamente a la persona participante que resulte ganadora y que acredite su identidad.",
    //   ],
    //         textonavidad:`¡Envía, participa y vive la magia con TUFESAPACK!
    //   Porque en esta Navidad, cada envío puede convertirse en un regalo inolvidable.
    //   #NavidadTUFESAPACK #CajaMágicaTUFESAPACK`,
    //   bases:`Los datos registrados en la PACK Esfera serán utilizados exclusivamente para identificar al participante y contactarlo en caso de resultar ganador. El tratamiento de la información se realizará conforme al Aviso de Privacidad disponible en www.tufesapack.com/aviso-de-privacidad. No se utilizarán para fines distintos ni se compartirán con terceros ajenos a la promoción.”\n
    //   La selección del ganador se realizará mediante el portal Appsorteos el día 20 de diciembre de 2025 a las 12:00 horas, en una transmisión en vivo en la página oficial de Facebook de TUFESAPACK. Se elegirán un ganador y dos suplentes para asegurar la correcta asignación del premio.\n
    //   El ganador será contactado vía llamada telefónica y correo electrónico con los datos proporcionados en su PACK Esfera. En caso de que el ganador no pueda ser localizado tras agotar los intentos razonables (número incorrecto, ausencia de respuesta, correo sin contestar), se asignará el premio al primer suplente y, de persistir la imposibilidad de contacto, al segundo suplente. La sucursal donde se haya depositado la PACK Esfera ganadora apoyará en la búsqueda presencial del participante para agotar todas las opciones de contacto antes de pasar a un suplente.`,
    //   imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_cajaMagica.webp"
    // },
    promohermosillo: {
      titulo: "Promoción Hermosillo",
      descripcion: `Hermosillo manda más, ¡y paga por menos!\n
    Aprovecha esta súper promo en Hermosillo:\n
    Solo $25 pesos la recolección y 25% de descuento en tu envío a cualquier destino dentro de la cobertura TUFESA (aplicable en conjunto con recolección).\n
    Pide tu recolección, paga en sucursal o al recoger y deja que nosotros hagamos el resto. ¡Es el momento ideal para mandar todo lo que quieras!`,
      beneficios: [],
      terminos: [
        "Promoción válida únicamente para envíos recolectados con origen en Hermosillo.",
        "Recolección con costo de $25.00 pesos + 25% de descuento en el envío solo si es en conjunto con recolección.",
        "Aplica solo en pagos realizados con efectivo, tarjeta de débito o crédito.",
        "El servicio a domicilio (entrega final) se paga por separado.",
        "El empaque y embalaje tienen costo adicional.",
        "Promoción válida del 7 de abril al 31 de julio de 2025.",
        "No acumulable con otras promociones o descuentos."
      ],
      imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_hermosillo.webp"
    },

    'manda-y-gana': {
      titulo: "Manda y Gana con TUFESAPACK",
      descripcion: `Envía a domicilio y participa para ganar un viaje a Mazatlán esta Semana Santa.`,
      tituloBeneficios: "¿Cómo participar?",
      beneficios: [
        "Realiza un envío a domicilio con TUFESAPACK.",
        "Regístrate con tus datos en el formulario oficial.",
        "Repite diariamente y aumenta tus oportunidades."
      ],

      terminos: [
        "La promoción es organizada por TUFESAPACK.",
        "Vigencia del 19 de enero al 25 de marzo de 2026.",
        "Selección del ganador realizado mediante herramienta digital aleatoria.",
        "El premio son dos boletos redondos para viajar en servicio PLUS de TUFESA para viajar durante los días domingo, 29 de marzo de 2026 al domingo, 5 de abril de 2026.",
        "El premio incluye únicamente los dos boletos redondos para viajar en TUFESA en su servicio PLUS con destino u origen Mazatlán.",
        "Los boletos son válidos únicamente del domingo 29 de marzo al domingo 05 de abril del 2026.",
        "De no utilizarse los boletos durante el periodo marcado, no habrá ningún tipo de compensación o reembolso.",
        "La participación implica la aceptación total de las bases.",
        "TUFESAPACK podrá verificar la validez de los registros.",
        "Cualquier intento de fraude anula la participación.",
        `La información proporcionada será utilizada exclusivamente para fines del giveaway. Los datos recabados serán tratados conforme al Aviso de Privacidad vigente, así como el medio para que los participantes puedan ejercer sus derechos ARCO. Consulta nuestro Aviso de Privacidad dando clic aquí: <a href="https://tufesapack.com/informacion/avisoPrivacidad" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>.`,
        "Facebook no patrocina, administra ni está asociado a esta promoción.",
        "Cualquier situación no prevista será resuelta por el comité organizador."
      ],

      imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_mandaYGana.webp"
    },
    'envios-que-enamoran': {
      titulo: "💝 Envíos que Enamoran",
      descripcion: `Este febrero, envía más y ahorra más con TUFESAPACK.

    Activa tu primer contrato prepago con guías WEB y recibe guías adicionales sin costo de acuerdo con el volumen que adquieras. Diseñada especialmente para PyMES, comercios locales y negocios que viven del envío.`,
      tituloBeneficios: "¿Cómo funciona?",
      beneficios: [
        "Contrata por primera vez guías WEB con TUFESAPACK.",
        "Realiza tu compra dentro del periodo promocional.",
        "Recibe guías adicionales según el volumen adquirido.",
        "Usa tus guías para enviar más durante la temporada de Amor y la Amistad."
      ],

      // nivelesTitulo: "Niveles de adquisición y beneficio",
      niveles: [
        { deposito: "Más de 100 guías", descuento: "+5 guías adicionales" },
        { deposito: "Más de 300 guías", descuento: "+15 guías adicionales" },
        { deposito: "Más de 500 guías", descuento: "+25 guías adicionales" },
        { deposito: "Más de 1000 guías", descuento: "+50 guías adicionales" }
      ],

      aplican: [
        "PyMES",
        "Tiendas en línea",
        "Comercios locales",
        "Creadores de regalos personalizados",
        "Clientes nuevos con primer contrato prepago y primer consumo"
      ],

      terminos: [
        "<b>Promoción válida únicamente del 09 al 13 de febrero de 2026.</b>",
        "La promoción aplica exclusivamente para clientes nuevos.",
        "La compra deberá realizarse únicamente en la modalidad de Guías Web y por medio de un ejecutivo de ventas.",
        "Los precios aplicables serán únicamente los establecidos en el tabulador vigente para Ejecutivos de Ventas; no se aceptarán precios inferiores, especiales o fuera de tabulador.",
        "El cliente recibirá guías adicionales conforme al volumen de guías adquiridas en una sola compra, de acuerdo con el siguiente esquema:",
        "Compra de más de 100 guías: +5 guías adicionales.",
        "Compra de más de 300 guías: +15 guías adicionales.",
        "Compra de más de 500 guías: +25 guías adicionales.",
        "Compra de más de 1,000 guías: +50 guías adicionales.",
        "Las guías adicionales se otorgarán únicamente conforme al rango alcanzado, no siendo acumulables entre rangos.",
        "Las guías adicionales se asignarán una vez confirmado el pago correspondiente.",
        "El Ejecutivo de Ventas deberá informar, mediante el alta del cliente, que participa en la presente promoción, para que el área de Crédito y Cobranza realice la asignación de las guías promocionales.",
        "La promoción es válida únicamente durante el periodo de vigencia establecido.",
        "La promoción no es acumulable con otras campañas, descuentos o promociones vigentes.",
        "Todas las guías adquiridas, incluidas las promocionales, estarán sujetas a las cláusulas y condiciones establecidas en el Contrato de Adhesión de Tufesapack.",
        "En caso de que las guías sean utilizadas con origen frontera, el cliente deberá cumplir con la documentación correspondiente requerida por el SAT, siendo responsabilidad exclusiva del cliente su correcta presentación.",
        "Cuando las guías correspondan a cobertura Tufesapack, estas estarán sujetas a la disponibilidad operativa de cada sucursal.",
        "Vigencia de las guías: un año a partir de su adquisición."
      ],

      // ✅ NUEVO APARTADO
      restricciones: [
        "No aplica para clientes activos, inactivos o cuentas previamente registradas en Tufesapack.",
        "Promoción no aplica en compras realizadas en página web Tufesapack.com.",
        "No aplica en envíos con convenios, tarifas especiales o precios distintos al tabulador vigente.",
        "Las guías adicionales no son transferibles, reembolsables ni canjeables por efectivo.",
        "El beneficio promocional no aplica de forma retroactiva a compras realizadas antes o después de la vigencia.",
        "La promoción aplica únicamente a una sola compra por cliente nuevo, independientemente del volumen adquirido en dicha compra.",
        "No se aceptan reclamaciones, devoluciones ni reembolsos relacionados con la promoción, las guías adquiridas o las guías adicionales otorgadas.",
        "El uso de las guías implica la aceptación total de estas bases y restricciones, así como del Contrato de Adhesión de Tufesapack."
      ],

      imagen: "assets/img/beneficios/IMGS-PROMOCION/post_promo_enviosQueEnamoran.webp",
      boton: "Comprar"
    },
  };

  constructor(private route: ActivatedRoute, private router: Router, private metaService: Meta) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code && this.infoPromo[code]) {
        this.dataActual = this.infoPromo[code];
      } else {
        this.router.navigate(['/']); // Redirige al inicio si code es inválido o nulo
      }
    });

    this.metaService.updateTag({ name: 'robots', content: 'noindex' });
  }

}